import { render } from "./ProductThumbnail.vue?vue&type=template&id=bb8394be"
import script from "./ProductThumbnail.js?vue&type=script&lang=js"
export * from "./ProductThumbnail.js?vue&type=script&lang=js"

import "./ProductThumbnail.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__